import { sharedInitialValues } from '../shared/sharedInitialValues';

export const initialValues = (values = {}) => ({
    employerType: 'Pracownik - osoba cywilna',
    employerCompanyName: '',
    nip: [{ value: '' }],
    dateOfIllness: new Date(),
    dateOfBackToWork: new Date(),
    childCare: 'no',
    childName: '',
    childSurname: '',
    childPesel: '',
    childRelation: '',
    importantInformation: '',
    yourRoleInWork: '',
    uploadedFile: [],
    ...sharedInitialValues(values),
});
